import { Container } from '@/components/ui/Grid';
import EditorOutput from '@/components/common/EditorOutput';
import MotionHeader from '@/components/ui/MotionHeader';
import styles from './production.module.scss';
import Link from 'next/link';

const Category = ({ category }) => {
  return (
    <Link href={`/catalog/category/${category.id}`}>
      <a className={styles.category}>
        <div className={styles.categoryName}>{category.title}</div>
        <div className={styles.categoryPhoto}>
          <img src={category.image} alt={category.title} />
        </div>
      </a>
    </Link>
  );
};

const Production = ({ data = { categories: [] } }) => {
  return (
    <Container>
      {data.title && <MotionHeader className={styles.header}>{data.title}</MotionHeader>}
      {data.text && <EditorOutput data={data.text} />}

      {data.categories && data.categories.length > 0 && (
        <div className={styles.grid}>
          {data.categories.map(c => (
            <div key={c.id} className={styles.categoryTile}>
              <Category category={c} />
            </div>
          ))}
        </div>
      )}
    </Container>
  );
};

export default Production;
